import { Theme } from "components/ThemeSwitcher/ThemeSwitcher";
import { IUserSettings } from "./types";

export const SET_USER_REGISTARTION_STEPS = "SET_USER_REGISTARTION_STEPS";
export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const SET_USER_SAVED_ACCOUNTS = "SET_USER_SAVED_ACCOUNTS";
export const CLEAR_CURRENT_USER_DATA = "CLEAR_CURRENT_USER_DATA";
export const SET_USER_CURATOR_DATA = "SET_USER_CURATOR_DATA";
export const SET_USER_CURATOR_DATA_LOADED = "SET_USER_CURATOR_DATA_LOADED";
export const SET_USER_INFO = "SET_USER_INFO";
export const SET_USER_CURRENCY = "SET_USER_CURRENCY";
export const SET_USER_SETTINGS = "SET_USER_SETTINGS";
export const UPDATE_USER_SETTINGS = "UPDATE_USER_SETTINGS";

export const defaultSettings: IUserSettings = {
    language: 'ru-RU',
    theme: Theme.AUTO,
    colorSet: 'default',
    sidebarOpen: true,
};